export default __webpack_public_path__ + "static/media/Mark-2-HUD-Mag, Dto, Data.fdd6dc76.jpg";